// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"styles_layoutContainer__rcIQH","main":"styles_main__8J1F0"};